import type { ManagerList } from './types'

/** Özetde gösterilecek en fazla ad; gerisi "+N" olarak yazılır. */
const SUMMARY_LIMIT = 3

/**
 * Bir listenin kişilerinin **satır özeti**: ilk birkaç ad, sonrası `+N`.
 *
 * <p>Tek kaynakta durur çünkü iki yüzey kullanıyor — geniş ekranda tablo kolonu, dar ekranda kart.
 * İkisi ayrı yazılsaydı aynı liste iki genişlikte farklı özetlenebilirdi.
 *
 * <p>Adı boş olan kişide sicile düşülür: {@code fullName} sunucuda ad+soyaddan türetilir ve ikisi de
 * boşsa boş dizedir — satırda boşluk göstermek kullanıcıya hiçbir şey söylemezdi.
 *
 * @param emptyText kişisi olmayan listede gösterilecek metin (çağıran taraf çevirir)
 */
export function peopleSummary(row: ManagerList, emptyText: string): string {
  if (row.people.length === 0) {
    return emptyText
  }
  const shown = row.people.slice(0, SUMMARY_LIMIT).map((p) => p.fullName || p.employeeId)
  const rest = row.people.length - shown.length
  return rest > 0 ? `${shown.join(', ')} +${rest}` : shown.join(', ')
}
